// ----------------------------------------------------------------
// <copyright company='Microsoft Corporation'>
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------

/**
 * List of supported environments
 */
export enum EnvironmentType {
    LocalHost,
    Integration,
    Production,
}

export interface IEnvironment {
    aadClientIdForWebUser: string;
    deployed: boolean;
    developerTelemetryKey: string;
    environmentType: EnvironmentType;
    hostname: string;
    name: string;
    oldRoboBaseUrl: string;
    production: boolean;
    telemetryKey: string;
    telemetryUrl: string;
    isAutoUserOnboarding: boolean;
    graphApiDirectoryUrl: string;
    jarvisEmailCheck: boolean;
}
